import {initializeClickableRowsContacts} from './functions';

document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector(".orders-page")) {
        initializeClickableRowsContacts();
    }

    function checkShippingCompany(element) {
        const customInput = document.getElementById('custom_shipping_company');
        if (element.val() === 'custom') {
            customInput.style.display = 'block';
        } else {
            customInput.style.display = 'none';
            customInput.value = ''; // Clear the input value when hidden
        }
    }

    function checkShippingType(element) {
        const shippingType = element.value.toLowerCase();
        const shippingAddress = $('.shipping-address');

        if (shippingType.startsWith('pickup')) {
            shippingAddress.hide();
            shippingAddress.find('input, select, textarea').each(function () {
                $(this).removeAttr('required');
            });
        } else {
            shippingAddress.show();
            shippingAddress.find('input, select, textarea').each(function () {
                if (!$(this).hasClass('not-required')) {
                    $(this).attr('required', 'required');
                }
            });
        }
    }

    function checkOrderType(orderType) {
        if (orderType === 'order' || orderType === 'pre_order') {
            $('#shipping_price, #fee_percent').closest('.input-container').parent().show();
        } else {
            $('#shipping_price, #fee_percent').closest('.input-container').parent().hide();
        }
    }

    function copyAddress() {
        const shippingType = $('#shipping_type').val().toLowerCase();
        if (!shippingType.startsWith('pickup')) {
            $('#shipping_to_company').val($('#billing_to_company').val());
            $('#shipping_address').val($('#billing_address').val());
            $('#shipping_country').val($('#billing_country').val());
            $('#shipping_state').val($('#billing_state').val());
            $('#shipping_city').val($('#billing_city').val());
            $('#shipping_zip').val($('#billing_zip').val());
            $('#shipping_phone').val($('#billing_phone').val());
            $('#shipping_email').val($('#billing_email').val());
        }
    }

    function calculateTotal() {
        let subtotal = 0;

        $('#productItemsContainer .product_item').each(function () {
            const quantity = parseFloat($(this).find('#quantity').val()) || 0;
            const price = parseFloat($(this).find('#price').val()) || 0;
            const total = quantity * price;

            $(this).find('#total').val(total.toFixed(2));
            subtotal += total;
        });

        const shippingPrice = parseFloat($('#shipping_price').val()) || 0;
        const feePercent = parseFloat($('#fee_percent').val()) || 0;
        const feeAmount = ((subtotal + shippingPrice) * feePercent) / 100;
        const totalAmount = subtotal + shippingPrice + feeAmount;

        $('#subtotal').text(subtotal.toFixed(2));
        $('#totalAmount').text(totalAmount.toFixed(2));
    }

    function productDescriptionVisibility(productElement) {
        const selectedOption = $(productElement).find('option:selected');
        const descriptionField = $(productElement).closest('.product_item').find('#description').closest('.col');
        if (selectedOption.data('desc') === 1) {
            descriptionField.removeClass('d-none');
        } else {
            descriptionField.addClass('d-none');
        }
    }

    if (document.querySelector(".order-create-page") || document.querySelector(".order-edit-page")) {
        let orderTypeSelect = $('#order_type');
        let shippingCompanySelect = $('#shipping_company');

        checkOrderType(orderTypeSelect.val());
        checkShippingType(document.getElementById('shipping_type'));
        checkShippingCompany(shippingCompanySelect);
        calculateTotal();

        orderTypeSelect.on('change', function () {
            checkOrderType($(this).val());
        });
        document.getElementById('shipping_type').addEventListener('change', function () {
            checkShippingType(this);
        });
        shippingCompanySelect.on('change', function () {
            checkShippingCompany(shippingCompanySelect);
        });
        $(document).on('change', '.product_quantity, .product_price', function (e) {
            const productItem = $(this).closest('.product_item');
            let quantity = parseFloat(productItem.find('#quantity').val());
            let price = parseFloat(productItem.find('#price').val());
            productItem.find('#total').val((quantity * price).toFixed(2));
        });
        $(document).on('input', '#productItemsContainer .product_item input, #shipping_price, #fee_percent', function () {
            calculateTotal();
        });
        $(document).on('change', '.product_select', function() {
            console.log('changed');
            const productItem = $(this).closest('.product_item');
            productItem.find('#quantity').val(1);
            productItem.find('#price').val(0);
            productItem.find('#total').val(0);

            productDescriptionVisibility(this);
        });
        const productItemsContainer = document.getElementById('productItemsContainer');
        const addProductItemButton = document.getElementById('addProductItem');

        // Add new product item
        addProductItemButton.addEventListener('click', () => {
            const productItemElement = $('#productItemsContainer .product_item');
            const productItem = productItemElement.first();
            const newProductItem = productItem.clone();


            newProductItem.find('#quantity').val(1);
            newProductItem.find('#price').val(0);
            newProductItem.find('#total').val(0);

            const newIndex = productItemElement.length;
            newProductItem.find('input, select, textarea').each(function () {
                const name = $(this).attr('name');
                if (name) {
                    const updatedName = name.replace(/\[\d+\]/, `[${newIndex}]`);
                    $(this).attr('name', updatedName);
                }
            });

            $('#productItemsContainer').append(newProductItem);
            newProductItem.find('.ts-wrapper').each(function () {
                $(this).remove();
            });

            const productElement = newProductItem.find('.product_select');
            productElement.removeClass('tomselected');
            productElement.removeClass('ts-hidden-accessible');
            productElement.val('')
            new TomSelect(productElement[0], {
                searchField: ['text'],
                create: false,
                maxOptions: 1000
            });
        });

        // Remove product item
        productItemsContainer.addEventListener('click', (event) => {
            if (event.target.classList.contains('remove-product-item')) {
                const productItem = event.target.closest('.product_item');
                if (productItemsContainer.children.length > 1) {
                    productItem.remove();
                } else {
                    alert('At least one product item is required.');
                }
            }
        });
    }

    if (document.querySelector(".order-create-page")) {
        $(document).ready(function () {
            let productItem = $('#productItemsContainer .product_item').first();
            let productElement = productItem.find('.product_select');

            new TomSelect(productElement, {
                searchField: ['text'],
                create: false,
                maxOptions: 1000
            });

            $('#copyBillingToShipping').on('click', function () {
                copyAddress();
            });
        });
    }

    if (document.querySelector(".order-edit-page")) {
        const form = document.getElementById('orderForm');
        const initialDisabledState = form.getAttribute('data-disabled') === 'true';

        if (initialDisabledState) {
            // Disable all form elements
            const formElements = form.elements;
            for (let i = 0; i < formElements.length; i++) {
                const element = formElements[i];
                if (!element.classList.contains('no-disabled')) {
                    if (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA') {
                        element.readOnly = true;
                    } else {
                        element.disabled = true;
                    }
                }
            }
        }

        document.querySelectorAll('.product_select').forEach(function (productElement) {
            new TomSelect(productElement, {
                searchField: ['text'],
                create: false,
                maxOptions: 1000
            });

            productDescriptionVisibility(productElement);
        });
    }
});
